define.alias("shared/components/shared/ui/blank-panel", "calendar/components/shared/ui/blank-panel");